<template>
  <div class="box is-faq-item">
    <div class="columns">
      <div class="column is-2" v-if="hasIcon">
        <img :src="data.product.logo">
      </div>

      <div :class="{ 'column': true, 'is-12': !hasIcon, 'is-10': hasIcon }">
        <h3 class="title is-6 has-margin-bottom-sm">{{ data.title }}</h3>

        <div class="content">
          <div v-html="data.content" class="has-margin-bottom-md" />

          <button
            type="button"
            v-if="$auth.check(['admin', 'support'])"
            class="button is-danger is-small"
            @click.prevent="destroy($event, data.id)">
            <b-icon icon="times" />
            <span v-t="'delete'" />
          </button>

          <div class="is-expand-link">
            <button
              type="button"
              :title="$t('read_more')"
              @click.prevent="expand($event, data.id)"
              class="button is-primary is-small">
              <span>
                &nbsp;&nbsp;&nbsp;
                <b-icon icon="angle-down" size="is-medium" />
                &nbsp;&nbsp;&nbsp;
              </span>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import Utils from '@/utils'

export default {
  name: 'QuestionBox',
  props: {
    data: { type: Object, required: true },
    hasIcon: { type: Boolean, default: true }
  },
  methods: {
    expand (event, questionId) {
      let btn = event.target
      let content = btn.closest('.content')
      let overlay = btn.closest('.is-expand-link')

      // Aumenta o número de visualizações da perguna
      this.increaseViews(questionId)

      content.style.overflow = 'auto'
      content.style.maxHeight = 'none'
      overlay.remove()
    },

    increaseViews (questionId) {
      API.questions.show(questionId)
    },

    // Remove a pergunta com base em sua ID
    destroy (event, id) {
      let box = event.target.closest('.is-faq-item')

      Utils.alertConfirmation(
        this.$t('delete_alert'),
        toast => {
          API.questions.destroy(id, () => {
            this.$snotify.remove(toast.id)
            box.style.background = '#ff0'
            Utils.fadeOut(box, 630, () => box.remove())
          })
        },
        toast => this.$snotify.remove(toast.id),
        this.$snotify
      )
    }
  }
}
</script>

<style lang="sass" scoped>
.is-faq-item
  border: 2px solid $white-bis
  .title
    color: $black-ter

.content
  position: relative
  max-height: 6rem
  overflow: hidden
  .is-expand-link
    background: $white
    background: linear-gradient(to bottom, rgba($white, 0) 0%, rgba($white, 1) 100%)
    position: absolute
    bottom: 0
    width: 100%
    height: 3rem
    text-align: center
    .button
      margin-top: 1.2rem
</style>

<i18n>
{
  "en-US": {
    "delete": "Remove this question",
    "delete_alert": "Are you sure you want to remove this question?",
    "read_more": "Read more"
  },
  "pt-BR": {
    "delete": "Remover esta pergunta",
    "delete_alert": "Tem certeza que deseja remover esta pergunta?",
    "read_more": "Continuar lendo"
  }
}
</i18n>
